import { FETCH_SUPPLIER } from '../constants/action-types';
import { httpService } from '../../index';

export function fetchSupplierTypes(id) {
  return httpService.request({
    path: `/suppliers/${id}/types`,
  });
}

export function fetchSupplier(id) {
  return httpService.request({
    path: `/suppliers-v2/${id}`,
  });
}

export const getSupplier = (id) => async (dispatch) =>
  dispatch({
    type: FETCH_SUPPLIER,
    payload: await fetchSupplier(id),
  });
